var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{ 'fas fa-angle-down' : _vm.isOpen, 'fas fa-angle-right' : !_vm.isOpen },on:{"click":_vm.toggle}})}
var staticRenderFns = []

export { render, staticRenderFns }